var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 49,
    viewBox: "0 0 74 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4 0V15.36C25.4 24.32 19.7 31.87 12.73 31.87C5.76001 31.87 0 24.32 0 15.36V0H3.39V15.36C3.39 22.78 7.55001 28.48 12.73 28.48C17.91 28.48 22.01 22.78 22.01 15.36V0H25.4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2004 16C73.2004 24.7 65.9704 31.93 57.3304 31.93C51.5104 31.93 46.3904 28.67 44.7904 26.04V48.37H41.4004V0H44.7904V5.95C46.3904 3.33 51.5104 0.13 57.3304 0.13C65.9704 0.13 73.2004 7.36 73.2004 16ZM69.8104 16C69.8104 9.02 64.3104 3.52 57.3304 3.52C50.3504 3.52 44.7904 9.02 44.7904 16C44.7904 22.98 50.2904 28.48 57.3304 28.48C64.3704 28.48 69.8104 22.98 69.8104 16Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/UP.82bddf4dc6460162e7e08350a461cb6f.svg";
export { ForwardRef as ReactComponent };